import React, {useState, useEffect} from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import apiUrl from '../../../Apiurl';

function CambiaDatoMassivo({ordiniSelezionati,updateFieldsAndValues,wheresAndValues,classe,testo,refresh,vista,deselezionaTutto,setAlertSalvataggio}) {

    //SUPPORTA IL VERSIONING

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    

    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);


    const impostaStato = async function() {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        let arrOrdini;
        if (!vista || vista !== "articoli") {
            arrOrdini  = ordiniSelezionati.map(ord => ({id: ord.id, versione:ord.versione}));
        } else {
            arrOrdini  = ordiniSelezionati.map(ord => ({id: ord.idSped, versione:ord.versione}));
        }
        console.log(arrOrdini);
        try {           
            const data = {
                arrOrdini: arrOrdini, // {id: number, versione: number}
                updateFieldsAndValues: updateFieldsAndValues,
                wheresAndValues: wheresAndValues,
                userName: user.name,
                funzione: "CambiaDatoMassivo"
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/logistica/funzioni/cambioMassivo", data, config)
                .then((resp) => {
                    if (resp.data.ordiniConErrore?.length>0) {
                        if (typeof setAlertSalvataggio === "function") {
                            setAlertSalvataggio(`ATTENZIONE! Gli ordini con id ${resp.data.ordiniConErrore.join()} non sono stati aggiornati perché sono stati modificati da un altro utente mentre avevi la pagina aperta. Prova ad aggiornare la pagina ed effettuare nuovamente la modifica.`);
                        } else {
                            console.warn("setAlertSalvataggio non disponibile");
                        }
                        //sarebbe bello caricare in lista ordini quelli che han dato errore ma per il momento mi affido al refresh
                    } else {
                        console.log("ok");
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio degli ordini alle API': " + err)
            throw err;
        }
        if (deselezionaTutto) {
            deselezionaTutto();
        }
        refresh();
    }

    return (        
            <button className={classe} onClick={impostaStato}>{testo}</button>
    )
}


export default CambiaDatoMassivo;
